import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { HttpEventType } from '@angular/common/http';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { InventoryItem } from '@contracts/interfaces/inventory-item.interface';
import { ConnectionService } from 'src/app/services/connection.service';
import { MediaService } from 'src/app/services/media.service';
import { InventoryService } from 'src/app/services/inventory.service';
import { ResponsiveService } from '../../services/responsive.service';
import { Media, MediaType } from '@contracts/interfaces/media.interfaces';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'app-item-media',
  templateUrl: './item-media.component.html',
  styleUrls: ['./item-media.component.scss']
})
export class ItemMediaComponent implements OnInit {


  @Input()
  public item: InventoryItem;

  @Input()
  public data: any;

  public mediaAddress: string = "";
  public mediaPath: string = "";
  public ticker = 0;

  public MediaType = MediaType;
  private mediaTypes = new WeakMap<Media, Observable<MediaType>>();

  constructor(
    private inventoryService: InventoryService,
    private mediaService: MediaService,
    private connectionService: ConnectionService,
    private responsiveService: ResponsiveService
  ) { }

  ngOnInit(): void {
    this.mediaAddress = this.connectionService.address + "/inventory/" + this.item.number + "/";
    this.mediaPath = "/inventory/" + this.item.number + "/";

    this.inventoryService.getMediaList(this.item).subscribe((r: any) => {
      let files = r.reply;
      // Check if there are any missing from item
      let notFound = [];
      for (let fileToFind of files) {

        let check = false;
        for (let media of this.item.media) {
          if (media.filename == fileToFind.filename) {
            check = true;
          }
        }

        if (!check) {
          notFound.push(fileToFind);
        }
      }

      for (let newMediaToAdd of notFound) {
        let media: Media = {
          filename: newMediaToAdd.filename,
          path: "/inventory/" + this.item.number
        };
        
        this.item.media.push(media);
      }

      if (notFound.length > 0) {
        this.save();        
      }
    })
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.item.media, event.previousIndex, event.currentIndex);
  }

  ngOnChanges(changes: SimpleChanges) {
    this.mediaPath = this.connectionService.address + "/inventory/" + this.item.number + "/";
  }

  mediaFilesToUpload: any[] = [];
  startUpload(evt) {
    for (let media of evt.addedFiles) {
      media.percentage = 0;
      media.totalSize = 0;
      media.mime = media.type;

      this.mediaFilesToUpload.push(media);
    }

    this.upload();
  }

  upload() {

    if (this.mediaFilesToUpload.length > 0) {
      
      let media: Media = {
        filename: this.mediaFilesToUpload[0].name,
        path: this.mediaPath
      }

      this.mediaService.upload(this.mediaFilesToUpload[0], media).subscribe((reply: any) => {

        if (reply.type === HttpEventType.UploadProgress) {
          this.mediaFilesToUpload[0].percentage = (reply.loaded / 1000 / 1000).toFixed(2);
          this.mediaFilesToUpload[0].totalSize = (reply.total / 1000 / 1000).toFixed(2);
        }
        if (reply.type === HttpEventType.DownloadProgress) {
  
        }
        if (reply.type === HttpEventType.Response) {
          // if image uploadeded successfully
          if (reply.body) {
            if (this.item.media == undefined) {
              this.item.media = []
            }
            
            media.filename = reply.body.filename;

            this.item.media.push(media);
  
            this.inventoryService.updateOne(this.item).subscribe(r => {
              this.mediaFilesToUpload.splice(0, 1);
              this.upload();
            });
          }
        }
      })
    }
  }

  getImageUrl2(media: Media) {
    let x = this.mediaAddress + media.filename + "?ticker=" + this.ticker + "&width=1080&background=rgb(70,70,70)" 
    console.log(x);
    return x;
  }

  getImageUrl(media: Media) {
    let x = "url('" + this.mediaAddress + media.filename + "?ticker=" + this.ticker + "&width=195&height=190&fit=cover&background=rgb(70,70,70)')";
    return x;
  }

  editVideo(media: Media, currentIndex?: number) {
    
  }

  editImage(media: Media, currentIndex?: number, view?: boolean) {

    let temp: Media[] = [];
    for (let media of this.item.media) {
      temp.push(media);
    }

    this.mediaService.edit(media, (action: any)=> {

      if (action == undefined) {
        return;
      }

      // TODO: Not sure if this actually works?
      if (action.type == "deleted" || action.type == "error") {
        this.item.media.splice(this.item.media.indexOf(media, 0), 1);
        this.item.log.push({
          text: "Deleted image",
          date: new Date(),
          data: {
            image: action.image
          }
        })
        this.save();
      } else if (action.type == "saved") {
        setTimeout(()=> {
          this.ticker = new Date().getTime();
        }, 500);
      }
    }, {
      index: currentIndex,
      list: temp,
      view: view
    });
  }

  save() {
    this.item.lastModified = new Date();
    this.inventoryService.updateOne(this.item).subscribe(r => { });
  }

  download(media: Media) {
    this.mediaService.download(media, true, (r)=> {});
  }

  removeMedia(media: Media, index: number) {
    this.mediaService.delete(media).subscribe(r => {
      this.item.media.splice(index, 1);

      this.save();
    }, error => {
      this.item.media.splice(index, 1);

      this.save();
    })
  }

  shiftMediaLeft(index: number) {
    if (index > 0) {
      moveItemInArray(this.item.media, index, index-1);
      this.save();
    }
  }

  shiftMediaRight(index: number) {
    if (index < this.item.media.length-1) {
      moveItemInArray(this.item.media, index, index+1);
      this.save();
    }
  }

  openImageDialogMobile(image: Media) {
    if (image != undefined) {
      if (this.responsiveService.isMobile()) {
        this.editImage(image);
      }
    }
  }

  getMediaSrc(media: Media) {
    return this.mediaAddress + media.filename;
  }

  getType(media: Media): Observable<MediaType> {
    let type = this.mediaTypes.get(media);
    if (!type) {
      type = this.mediaService.getType(media).pipe(
        map((value: MediaType) => value),
        catchError(() => of(MediaType.NONE)),
        shareReplay({ bufferSize: 1, refCount: true })
      );
      this.mediaTypes.set(media, type);
    }
    return type;
  }

}
